import React from 'react';
import { GridColumn as Column } from '@progress/kendo-react-grid'
import { IFormGridProps } from 'library/types/IFormGridProps'
import { SystemGrid } from 'library'
import { SystemActionCell } from '../../library/grid/SystemActionCell';

const CenteredHeaderCell = (props) => {
    return (
        <span className={'TextCenter'}>
            {props.title}
        </span>
    );
};
const ChartColor = (props: IFormGridProps) => {
    const url = "/ChartColors/";

    const [counter, setCount] = React.useState(1500);

    const RefreshGrid = () => {
        setTimeout(() => {
            setCount(counter + 1);
        }, 500)
    }

    return <SystemGrid onRowClick={props.onRowClick} pageable={true} dataSource={url} refresh={props.refresh + counter} >
        <Column key={1} field="Color" cell={(props) => {
            return (<><td style={{ justifyContent: "center", display: "flex" }} ><span style={{ backgroundColor: props.dataItem.Color, width: "40px", height: "25px", display: "block" }} ></span></td></>)
        }} title="Color" width="100" />
        <Column key={2} field="SortOrder" title="Sort Order" width="auto" />
        <Column key={3} field="" title="Action" width="auto" cell={(props) => <SystemActionCell {...props} onDeleteSuccess={RefreshGrid} showDelete={true} showAudit={false} schema="Top" table="ChartColors" deleteUrl='/ChartColors' />} columnMenu={null} headerCell={CenteredHeaderCell} />
    </SystemGrid>
}

export default ChartColor